import { ITransactionEstimate } from '@epi-models/containers/LoadCompanyAccount';
import { ICheckableBenefit } from '@epi-models/components/EstimationDetails';

export const calculateComission = (
  benefitDetails: ICheckableBenefit[],
  estimation: ITransactionEstimate
): number => {
  const benefitsComission = benefitDetails.reduce((prev, curr) => {
    return curr.checked
      ? prev + (curr.commission || 0) + (curr.commissionVAT || 0)
      : prev;
  }, 0);
  return (
    estimation.requestedLoads.commission +
    estimation.requestedLoads.commissionVAT +
    benefitsComission
  );
};

export const calculateSuggestedTransferAmount = (
  benefitDetails: ICheckableBenefit[],
  totalSuggestedTransfer: ITransactionEstimate['totalSuggestedTransfer']
): number => {
  const uncheckedBenefitsAmount = benefitDetails.reduce((prev, curr) => {
    return curr.checked
      ? prev
      : prev +
          curr.value +
          (curr?.commission ?? 0) +
          (curr?.commissionVAT ?? 0);
  }, 0);
  return totalSuggestedTransfer - uncheckedBenefitsAmount;
};
